(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_si", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_si"] = factory();
	else
		root["locale/locale_si"] = factory();
})(window, function() {
return 